import { render, staticRenderFns } from "./BenefitCard.vue?vue&type=template&id=91611074&"
import script from "./BenefitCard.vue?vue&type=script&lang=ts&"
export * from "./BenefitCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports